import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "topPanel topPanel-skeleton" };
const _hoisted_3 = { class: "transactions-skeleton" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    class: "topPanel",
    style: {}
};
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { usePolling } from '@/composables/usePolling';
import BankCard from './elements/BankCard.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import TransactionsList from './elements/TransactionsList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankAccount, deleteBankAccount, clearBankingInfo, getBankingInfo } = useBanking();
        const { poll } = usePolling('banking');
        const updatingTransactionId = ref(null);
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        function peekingDrawerBottom() {
            const c = cookies?.get('sb');
            let ret = 44;
            if (c) {
                ret += parseInt(c);
            }
            return ret + 'px';
        }
        function getTransactionClassificationId(transactionId) {
            if (!state.bankAccount?.groupedTransactions)
                return null;
            for (const group of state.bankAccount.groupedTransactions) {
                const t = group.find((t) => t.id === transactionId);
                if (t)
                    return t.effectiveClassification?.id ?? null;
            }
            return null;
        }
        function refreshTransaction(transactionId) {
            const originalId = getTransactionClassificationId(transactionId);
            updatingTransactionId.value = transactionId;
            poll({
                remaining: 5,
                interval: 2000,
                fetch: (onSuccess) => getBankAccount(route.params.id, onSuccess, false, true),
                onPoll: () => { },
                shouldStop: () => getTransactionClassificationId(transactionId) !== originalId,
                onFinish: () => {
                    updatingTransactionId.value = null;
                    getBankingInfo(null, true);
                },
            });
        }
        function deleteAccount() {
            deleteBankAccount(route.params.id, () => {
                clearBankingInfo();
                getBankingInfo(null, true);
                router.push('/money');
            });
        }
        onMounted(() => {
            getCustomer();
            getBankAccount(route.params.id);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    del: true,
                    edit: true,
                    onDelete: deleteAccount,
                    title: _unref(state).bankAccount ? (_unref(state).bankAccount.bank.prettyName ? _unref(state).bankAccount.bank.prettyName : _unref(state).bankAccount.bank.name) : 'Account',
                    bgcolor: '#332847',
                    color: 'white',
                    border: false
                }, null, 8, ["title"]),
                (!_unref(state).customer || !_unref(state).bankAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_skeleton_loader, {
                                type: "image",
                                class: "bank-card-skeleton"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).bankAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(BankCard, {
                                        account: _unref(state).bankAccount,
                                        formatter: _unref(state).formatter
                                    }, null, 8, ["account", "formatter"])
                                ]),
                                _createVNode(DrawerPanel, {
                                    bottom: peekingDrawerBottom(),
                                    title: "Recent Transactions",
                                    backgroundColor: "white",
                                    openBackgroundColor: "white",
                                    closedHeight: "52%",
                                    contentAlwaysVisible: true
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(TransactionsList, {
                                            showDateTotal: true,
                                            search: true,
                                            transactions: _unref(state).bankAccount.groupedTransactions,
                                            formatter: _unref(state).formatter,
                                            today: _unref(state).today,
                                            yesterday: _unref(state).yesterday,
                                            updatingTransactionId: updatingTransactionId.value,
                                            onRefreshTransaction: _cache[0] || (_cache[0] = (t) => { refreshTransaction(t); })
                                        }, null, 8, ["transactions", "formatter", "today", "yesterday", "updatingTransactionId"])
                                    ]),
                                    _: 1
                                }, 8, ["bottom"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
